import * as React from 'react'

export const SVG_Magnifier2 = () => (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_5772_207988)">
            <path
                d="M17.0743 29.1379C19.7557 29.138 22.3605 28.2433 24.476 26.5956L32.4569 34.5766C33.0531 35.1524 34.0031 35.1359 34.5789 34.5397C35.1406 33.9581 35.1406 33.0361 34.5789 32.4546L26.598 24.4736C30.6866 19.2104 29.7345 11.6293 24.4713 7.54067C19.2082 3.45203 11.6271 4.40413 7.53847 9.66731C3.44984 14.9305 4.40194 22.5116 9.66511 26.6002C11.784 28.2463 14.3911 29.1393 17.0743 29.1379ZM10.6617 10.6593C14.2033 7.11756 19.9454 7.1175 23.4871 10.6591C27.0288 14.2008 27.0289 19.9429 23.4873 23.4846C19.9456 27.0263 14.2035 27.0263 10.6618 23.4847C10.6617 23.4846 10.6617 23.4846 10.6617 23.4846C7.12004 19.9688 7.09918 14.2476 10.615 10.7059C10.6305 10.6903 10.6461 10.6748 10.6617 10.6593Z"
                fill="currentColor"
            />
        </g>
        <defs>
            <clipPath id="clip0_5772_207988">
                <rect width="30" height="30" fill="white" transform="translate(5 5)" />
            </clipPath>
        </defs>
    </svg>
)
